import { ZONES } from '@/utils/constants';
import type { Zone } from '@/types/zones/zone';

export type ProcessExclusiveZoneResult = {
    exclusiveZoneEnabled: boolean;
    zonesWithAutomaticPopup: Zone | null;
};

/**
 * Processes zones array to determine if exclusive zones are enabled
 * and if any have automatic popup enabled
 * Matches the logic from the old project's processExclusiveZone helper
 */
export const processExclusiveZone = (zones: Zone[] | undefined | null): ProcessExclusiveZoneResult => {
    const zonesArray = Array.isArray(zones) ? zones : [];
    const exclusiveZones = zonesArray.filter((zone) => zone.type === ZONES.EXCLUSIVE_LAUNCH);
    const exclusiveZoneEnabled = exclusiveZones.length > 0;

    if (exclusiveZoneEnabled) {
        const zonesWithAutomaticPopup = exclusiveZones.find(
            (exclusiveZone) => exclusiveZone?.data?.show_popup_at_login
        );
        if (zonesWithAutomaticPopup) {
            return { exclusiveZoneEnabled, zonesWithAutomaticPopup };
        }
        return { exclusiveZoneEnabled, zonesWithAutomaticPopup: null };
    }

    return { exclusiveZoneEnabled: false, zonesWithAutomaticPopup: null };
};
